import { ORIGIN_TWITTER, ORIGIN_INSTAGRAM } from '@/constants/origin.js';

export const isSociallyIngestedContent = (content) => content.origin === ORIGIN_TWITTER || content.origin === ORIGIN_INSTAGRAM;
